export enum AbsenceTypeEnumeration {
	SICKNESS = 'illness',
	ACCIDENT = 'accident',
	PREGNANCY = 'pregnancy',
}
